import { useMemo } from "react";

import type { SnackList_SnackListPageQuery } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";

import { DesignSnackListItem } from "./list-item";

type Props = {
	hotelID: string;
	data: SnackList_SnackListPageQuery;

	onDelete: ({ uuid, title }: { uuid: string; title: string }) => Promise<void>;
};

export const DesignSnackList = ({ hotelID, data, onDelete }: Props) => {
	const { snackList, snackSettings } = data;
	const { snacks } = snackList;

	/**
	 * スナックリストを表示できるか
	 */
	const canSHowSnackList = useMemo(() => snacks.length > 0, [snacks.length]);

	return (
		<>
			{canSHowSnackList ? (
				<div className="flex flex-col gap-y-4">
					{snacks.map((snack) => {
						return (
							<DesignSnackListItem
								key={snack.uuid}
								hotelID={hotelID}
								snack={snack}
								snackSettings={snackSettings}
								onDelete={onDelete}
							/>
						);
					})}
				</div>
			) : (
				<BlankContentForList
					content={`スナックがありません。\n新規作成ボタンからスナックを作成してください。`}
				/>
			)}
		</>
	);
};

DesignSnackList.displayName = "DesignSnackList";
